import { ciCalendar } from '~/icons/source/regular/calendar'
import { ciDoors } from '~/icons/source/regular/doors'
import { ciFuel } from '~/icons/source/regular/fuel'
import { ciMileage } from '~/icons/source/regular/mileage'
import { ciMotor } from '~/icons/source/regular/motor'
import { ciOdometer } from '~/icons/source/regular/odometer'
import { ciGearshift } from '~/icons/source/light/gearshift'
import { ciBatteryRange } from '~/icons/source/regular/battery-range'
import { ciChargeTime } from '~/icons/source/regular/charge-time'

export const regularKeyFeaturesIcons = Object.freeze({
  age: {
    icon: ciCalendar
  },
  registration: {
    icon: ciCalendar
  },
  mileage: {
    icon: ciMileage
  },
  engine_size: {
    icon: ciMotor
  },
  battery_range: {
    icon: ciBatteryRange
  },
  battery_charge_time: {
    icon: ciChargeTime
  },
  fuel_type: {
    icon: ciFuel
  },
  engine_power: {
    icon: ciOdometer
  },
  gearbox_type: {
    icon: ciGearshift
  },
  year_of_construction: {
    icon: ciCalendar
  },
  gears: {
    icon: ciGearshift
  },
  doors: {
    icon: ciDoors
  }
})
